import { AdType } from 'core/rtbCampaign/RtbCampaign';
import { useMemo } from 'react';
import { useCampaignStore } from 'store/campaignStore';
import { useOrderStore } from 'store/orderStore';

export const useBidRange = () => {
  const { order } = useOrderStore();
  const { adType } = useCampaignStore();

  const bidRange = useMemo(() => {
    const { bidFloor, autoBidCap } =
      order.campaignBidPrice.find(({ type }) => type === adType) || {};
    switch (adType) {
      case AdType.DISPLAY:
        return [bidFloor?.cpm || 0, autoBidCap?.cpm || Infinity];
      case AdType.KEYWORD:
        return [bidFloor?.cpc || 0, autoBidCap?.cpc || Infinity];
      case AdType.SMART_KEYWORD:
        return [bidFloor?.cpc || 0, autoBidCap?.cpc || Infinity];
      case AdType.MAX_CVR_KEYWORD:
        return [bidFloor?.cpc || 0, autoBidCap?.cpc || Infinity];
      case AdType.SHOP:
        return [bidFloor?.cpc || 0, autoBidCap?.cpc || Infinity];
      case AdType.RECOMMEND:
        return [bidFloor?.cpc || 0, autoBidCap?.cpc || Infinity];
      default:
        return [0, Infinity];
    }
  }, [adType, order.campaignBidPrice]);

  return bidRange;
};
